<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="county_not_found">
      <span>County record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'admin-counties'}" class="text-inherit underline">All Counties</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="county_data">
      <vx-card title="Transaction Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">County Name</td>
                <td>{{ county_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Promoter Name</td>
                <td><router-link :to="`/admin/users/promoter/view/${county_data.users[0].id}`" class="text-inherit underline hover:text-primary">{{ county_data.users[0].name }}</router-link></td>
              </tr>
              <tr>
                <td class="font-semibold">Assigned Date</td>
                <td>{{ county_data.county_assigned_date}}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">State Name</td>
                <td>{{ county_data.state_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">State Code</td>
                <td>{{ county_data.state_code }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <!--<vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{name: 'service-request-edit', params: { id: $route.params.id }}"
            >Edit</vs-button>-->
            <!--<vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
            >Delete</vs-button>-->
          </div>
        </div>
      </vx-card>

      <vx-card v-if="county_data.vendors.length">
        <vs-tabs>
          <vs-tab label="Vendors" icon-pack="feather" v-if="county_data.vendors.length" icon="icon-user">
            <div>
              <vs-table search @selected="directToVendor" max-items="10" pagination :data="county_data.vendors">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Business</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Min Budget</vs-th>
                  <vs-th>Distance</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].user.name">{{ data[indextr].user.name }}</vs-td>

                    <vs-td :data="data[indextr].business_name">{{ data[indextr].business_name }}</vs-td>

                    <vs-td :data="data[indextr].location">{{ data[indextr].location }}</vs-td>

                    <vs-td :data="data[indextr].user.vendor_additional.attributes.budget">{{ data[indextr].user.vendor_additional.attributes.budget }}</vs-td>

                    <vs-td :data="data[indextr].user.vendor_additional.attributes.willing_to_travel">{{ data[indextr].user.vendor_additional.attributes.willing_to_travel }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleAdmin from '@/store/admin/moduleAdmin.js'

export default {
  data () {
    return {
      county_data: null,
      county_not_found: false
    }
  },
  methods: {
    directToVendor (tr) {
      this.$router
        .push(`/admin/users/vendor/view/${tr.user.id}`)
        .catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.county_data.order_id}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      /*this.$router.push({ name: "app-user-list" })
        this.showDeleteSuccess()*/

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch('admin/deleteTransaction', this.county_data.id)
        .then(()   => { this.$router.push({name:'transactions'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Transaction Deleted',
        text: 'The transaction was successfully deleted'
      })
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'County')
    // Register Module UserManagement Module
    if (!moduleAdmin.isRegistered) {
      this.$store.registerModule('admin', moduleAdmin)
      moduleAdmin.isRegistered = true
    }

    const id = this.$route.params.id
    this.$store
      .dispatch('admin/fetchCounty', id)
      .then((res) => {
        this.county_data = res.data.data
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.county_not_found = true
          return
        }
        console.error(err)
      })
  }
}
</script>

<style lang="scss">
  #avatar-col {
    width: 10rem;
  }

  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: 0.8rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }

    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;

    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
  }
</style>
